const LYO_SEARCH_VIEW = 'lyo';
const LYO_PREDICTIVE_SEARCH_SECTION = 'lyo-predictive-search';
const LYO_PREDICTIVE_SEARCH_EMPTY_SECTION = 'lyo-predictive-search-empty';
const observedPredictiveSearchComponents = new WeakSet();
let lyoEmptyProductsRequest = null;

function navigateToLyoSearch(form, searchInput) {
  const searchUrl = new URL(form.action, window.location.origin);
  searchUrl.searchParams.set('q', searchInput.value);
  searchUrl.searchParams.set('type', 'product');
  searchUrl.searchParams.set('view', LYO_SEARCH_VIEW);
  searchUrl.searchParams.set('options[prefix]', 'last');
  window.location.assign(searchUrl.toString());
}

function fetchLyoEmptyProducts() {
  if (!lyoEmptyProductsRequest) {
    const searchForm = document.querySelector('.predictive-search-form');
    const searchUrl = new URL(searchForm?.action || '/search', window.location.origin);
    searchUrl.searchParams.set('section_id', LYO_PREDICTIVE_SEARCH_EMPTY_SECTION);

    lyoEmptyProductsRequest = fetch(searchUrl)
      .then((response) => {
        if (!response.ok) throw new Error(`Unable to load Lyo search empty state: ${response.status}`);
        return response.text();
      })
      .then((markup) => {
        const products = new DOMParser()
          .parseFromString(markup, 'text/html')
          .querySelector(
            '.lyo-predictive-search-empty-section #predictive-search-products'
          );
        if (!(products instanceof HTMLElement)) {
          throw new Error('Lyo search empty products markup is missing');
        }
        return products;
      })
      .catch((error) => {
        lyoEmptyProductsRequest = null;
        console.error(error);
        return null;
      });
  }

  return lyoEmptyProductsRequest;
}

async function replaceDefaultEmptyProducts(component) {
  const searchInput = component.querySelector('input[name="q"]');
  const resultsContainer = component.querySelector('.predictive-search-form__content');
  let currentProducts = resultsContainer?.querySelector('#predictive-search-products');

  if (
    !(searchInput instanceof HTMLInputElement) ||
    !(resultsContainer instanceof HTMLElement) ||
    !(currentProducts instanceof HTMLElement) ||
    searchInput.value.trim() !== '' ||
    !currentProducts.querySelector('.resource-card')
  ) {
    return;
  }

  const lyoEmptyProducts = await fetchLyoEmptyProducts();
  currentProducts = resultsContainer.querySelector('#predictive-search-products');

  if (
    !(lyoEmptyProducts instanceof HTMLElement) ||
    !(currentProducts instanceof HTMLElement) ||
    searchInput.value.trim() !== '' ||
    !currentProducts.querySelector('.resource-card')
  ) {
    return;
  }

  const replacement = lyoEmptyProducts.cloneNode(true);
  if (!(replacement instanceof HTMLElement)) return;

  const recentlyViewed = currentProducts.querySelector('[ref="recentlyViewedWrapper"]');
  if (recentlyViewed) {
    replacement.prepend(recentlyViewed);
  }

  currentProducts.replaceWith(replacement);
}

function configureLyoPredictiveSearch() {
  document.querySelectorAll('predictive-search-component').forEach((component) => {
    if (!(component instanceof HTMLElement)) return;

    component.dataset.sectionId = LYO_PREDICTIVE_SEARCH_SECTION;
    if (observedPredictiveSearchComponents.has(component)) return;

    const resultsContainer = component.querySelector('.predictive-search-form__content');
    if (!(resultsContainer instanceof HTMLElement)) return;

    observedPredictiveSearchComponents.add(component);
    new MutationObserver(() => replaceDefaultEmptyProducts(component)).observe(resultsContainer, {
      childList: true,
      subtree: true,
    });
    replaceDefaultEmptyProducts(component);
  });
}

configureLyoPredictiveSearch();
document.addEventListener('shopify:section:load', configureLyoPredictiveSearch);

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const viewAllButton = target.closest('.predictive-search__search-button');
  if (!(viewAllButton instanceof HTMLButtonElement)) return;

  const form = viewAllButton.closest('.predictive-search-form');
  const searchInput = form?.querySelector('input[name="q"]');
  if (!(form instanceof HTMLFormElement) || !(searchInput instanceof HTMLInputElement)) return;

  event.preventDefault();
  navigateToLyoSearch(form, searchInput);
});

document.addEventListener(
  'keydown',
  (event) => {
    const target = event.target;
    if (
      event.key !== 'Enter' ||
      !(target instanceof HTMLInputElement) ||
      !target.matches('.predictive-search-form input[name="q"]')
    ) {
      return;
    }

    const form = target.closest('.predictive-search-form');
    if (!(form instanceof HTMLFormElement)) return;

    const hasSelectedResult = Boolean(form.querySelector('[aria-selected="true"]'));
    const hasSingleResult = Boolean(form.querySelector('[data-single-result-url]'));
    if (hasSelectedResult || hasSingleResult) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    navigateToLyoSearch(form, target);
  },
  true
);
